import contact from 'src/i18n/fr/validations/contact';
import creditcard from 'src/i18n/fr/validations/creditcard';
import login from 'src/i18n/fr/validations/login';
import invoice from 'src/i18n/fr/validations/invoice';
import organisation from 'src/i18n/fr/validations/organisation';

const validations = {
  contact,
  creditcard,
  invoice,
  login,
  organisation,
};

export default validations;
